export const FLAG_GETTING_PREVENTIVE_REPORT = 'FLAG_GETTING_PREVENTIVE_REPORT';
export const GET_PREVENTIVE_REPORT = 'GET_PREVENTIVE_REPORT';
export const CLEAR_PREVENTIVE_REPORT = 'CLEAR_PREVENTIVE_REPORT';
